import { ReactElement, useEffect } from 'react';
import { FormFieldText } from '@client/common/components/Form/FormFieldText';
import { getErrorMessage } from '@client/common/utils/form/form';
import { useTranslate } from '@client/i18n/hooks';
import { useFormikContext } from 'formik';
import { ModalButtons } from 'b2b-components/core/components/Modal';
import { BUTTON_TYPE } from 'b2b-components/theme/components/Button';
import { FIELD_NAME } from '../FormContainer.types';
import { Props } from './Body.types';

export const Body = ({
  onDiscardClick,
}: Props): ReactElement => {
  const {
    errors,
    handleSubmit,
    isSubmitting,
    touched,
    validateForm,
  } = useFormikContext();
  const t = useTranslate();

  useEffect(() => {
    validateForm();
  }, []);

  return (
    <form onSubmit={handleSubmit}>
        <FormFieldText
          name={FIELD_NAME.email}
          innerComponentProps={{
            error: getErrorMessage(
              errors[FIELD_NAME.email],
              touched[FIELD_NAME.email] || false,
            ),
            maxLength: 76,
            text: {
              label: t('Email'),
              required: '*',
            },
          }}
        />

      <ModalButtons
        primary={{
          label: isSubmitting
            ? t('Submitting...')
            : t('Submit'),
          type: BUTTON_TYPE.submit,
        }}
        cancel={{
          label: t('Cancel'),
          onClick: onDiscardClick,
        }}
      />
    </form>
  );
};
